<template>
  <div class="content_con">
    <p class="text-center" style="margin-bottom: 20px">
      <span class="title">东进公司东莞市内林业服务岗位外包采购项目（重新采购）</span>
    </p>
    <p class="text-left text-indent-37 line-height-39 content">
      一、<span class="heading">项目信息</span>
    </p>
    <p class="text-left text-indent-37 line-height-39">
      <span class="content">
        1、项目名称：<span class="underline"
          >&nbsp;东进公司东莞市内林业服务岗位外包采购项目（重新采购）&nbsp;</span
        >
      </span>
    </p>
    <p class="text-left text-indent-37 line-height-39">
      <span class="content">
        2、项目编号：<span class="underline">&nbsp;DJFK-GW-05-01-002（2025）</span>
      </span>
    </p>
    <p class="text-left text-indent-37 line-height-39">
      <span class="content">
        3、采购范围：<span class="underline">&nbsp;东莞市内林业服务岗位&nbsp;</span>
      </span>
    </p>
    <p class="text-left text-indent-37 line-height-39">
      <span class="content">
        4、项目地点：<span class="underline">&nbsp;采购人指定交货地址&nbsp;</span>
      </span>
    </p>
    <p class="text-left text-indent-37 line-height-39">
      <span class="content">
        5、服务时间（供货时间/工期）：<span class="underline"
          >&nbsp;合同签订日起订2年&nbsp;</span
        >
      </span>
    </p>
    <p class="text-left text-indent-37 line-height-39">
      <span class="content block">
        6、<span class="star"></span>
        供应商必须清楚理解：本协议采购项目的取得并不意味着必然获得单项采购项目的服务机会，采购人无法预计且无法保证中标人所能获得的数量和采购金额。在服务期限内，根据采购服务项目的具体情况，采购方仍有权通过其他合法方式选择中标供应商之外的其他单位提供本采购文件的服务内容。
      </span>
    </p>

    <p class="text-left text-indent-37 line-height-39 content">
      二、<span class="heading">采购说明及需求清单</span>
    </p>
    <p class="text-left text-indent-37 line-height-39">
      <span class="content"
        >本项目共有 <span class="block">1</span> 包。<span class="block">A1</span>
        包共需采购服务单位
        <span class="block">3</span> 家。采购具体内容及要求详见附件。</span
      >
    </p>

    <p class="text-left text-indent-37 line-height-39 content">
      三、<span class="heading">项目发布</span>
    </p>

    <p class="text-left text-indent-37 line-height-39">
      <span class="content">
        1、<span
          >本项目在东莞实业投资控股集团有限公司-招标采购栏目：<a
            class="block"
            target="_blank"
            href="http://www.dgsy.com.cn/"
            >http://www.dgsy.com.cn/</a
          >
          发布。</span
        >
      </span>
    </p>
    <p class="text-left text-indent-37 line-height-39">
      <span class="content">
        2、<span
          >网上公示期限为 <span class="block">6</span> 天，即
          <span class="block underline">2025年7月8日</span> 至
          <span class="block underline">2025年7月14日</span>。</span
        >
      </span>
    </p>

    <p class="text-left text-indent-37 line-height-39 content">
      四、<span class="heading">响应人资格要求</span>
    </p>

    <p class="text-left text-indent-37 line-height-39">
      <span class="content">
        1、<span
          >响应人须为在中华人民共和国境内登记注册的具有独立承担民事责任能力的法人或其他组织。【提供《营业执照》复印件（加盖公章）或《事业单位法人证书》复印件（加盖公章）或其他主体证书复印件（加盖公章）】。</span
        >
      </span>
    </p>
    <p class="text-left text-indent-37 line-height-39">
      <span class="content">
        2、<span
          >未被列入东实集团及下属企业相关领域黑名单。【以东莞实业投资控股集团有限公司发文（<span
            class="block"
            >东实通〔2021〕44号</span
          >）、（<span class="block">东实通〔2021〕98号</span>）、（<span class="block"
            >东实通〔2022〕75号</span
          >）（<span class="block">东实通〔2023〕37号</span
          >）为准，如有最新发文通知，按最新文件执行。</span
        >
      </span>
    </p>
    <p class="text-left text-indent-37 line-height-39">
      <span class="content">
        3、<span
          >供应商未被列入“信用中国”网站（<a
            class="block"
            target="_blank"
            href="https://www.creditchina.gov.cn/"
            >https://www.creditchina.gov.cn/</a
          >)“记录失信被执行人或重大税收违法案件当事人名单或政府采购严重违法失信行为”记录名单；同时，不处于中国政府采购网（<a
            class="block"
            target="_blank"
            href="http://www.ccgp.gov.cn/"
            >http://www.ccgp.gov.cn/</a
          >）“政府采购严重违法失信行为信息记录”中的禁止参加政府采购活动期间；以及未被工商行政管理机关在“国家企业信用信息公示系统”网站（<a
            class="block"
            target="_blank"
            href="https://www.gsxt.gov.cn"
            >https://www.gsxt.gov.cn</a
          >）中列入严重违法失信企业名单；（需提供以上网址网上查询认证渠道截图，截图必须显示供应商单位名称并加盖公章。）</span
        >
      </span>
    </p>
    <p class="text-left text-indent-37 line-height-39">
      <span class="content">
        4、<span
          >业绩要求：响应人具备<span class="block">同类的</span>项目经验，要求<span
            class="block"
            >2023年07月09日</span
          >起至本项目开标日前，完成至少 <span class="block">3</span> 个的<span
            class="block"
            >同类的合同</span
          >业绩。【按合同签订时间为准，须提供合同关键页复印件(包含但不限于合同首页、合同金额页、合同签字页等)、相关发票或完税证明等证明材料】。</span
        >
      </span>
    </p>

    <p class="text-left text-indent-37 line-height-39 content">
      五、<span class="heading">报价</span>
    </p>
    <p class="text-left text-indent-37 line-height-39">
      <span class="content">
        <span
          >采购限价：按清单分项报价（含税）及汇总，<span class="underline"
            >报价应精确到
            <span class="block">2</span>
            位小数点</span
          >
          。
        </span>
      </span>
    </p>
    <p class="text-left text-indent-37 line-height-39">
      <span class="content">
        <span
          >本项目发包方式为固定单价包干，实行固定价格报价，包括但不限于：完成本项目的成本、利润、税金等在项目过程中可能产生的一切费用。响应人已充分考虑了本项目服务内容及要求描述工作量可能与最终实际工作量存在差距的风险。
        </span>
      </span>
    </p>

    <p class="text-left text-indent-37 line-height-39 content">
      六、<span class="heading">定标方法</span>
    </p>
    <p class="text-left text-indent-37 line-height-39">
      <span class="content">
        <span
          >本次项目采用公开询价方式进行采购，采购小组对各供应商响应文件进行审核，在符合资格条件的供应商中，采购小组根据最终报价和根据质量和服务均能满足采购文件实质性响应要求且报价最低的原则，推荐报价最低的<span
            class="block"
            >3</span
          >家为成交候选供应商。
        </span>
      </span>
    </p>
    <p class="text-left text-indent-37 line-height-39">
      <span class="content">
        <span>询价结束后，招标采购工作小组将相关询价情况按程序审批并确定成交人。 </span>
      </span>
    </p>
    <p class="text-left text-indent-37 line-height-39 content">
      七、<span class="heading">支付方式</span>
    </p>
    <p class="text-left text-indent-37 line-height-39">
      <span class="content">
        1、<span
          >付款形式为按月支付（每月据实结算上月费用），采购人应当根据中标单位实际进场人数、服务时间、服务质量参照附件1进行综合考核，并基于考核结果及采购人需求人数、需求档位、时间安排等因素确定月度实际服务费用。双方项目负责人签字确认服务费用后，采购人在收到中标单位全部请款资料和等额增值税专用发票后15个工作日内支付服务费。
        </span>
      </span>
    </p>
    <p class="text-left text-indent-37 line-height-39">
      <span class="content">
        2、<span
          >每次付款前，中标单位必须提供合法有效、与本合同价款条款中增值税税率一致的增值税专用发票给采购人，否则采购人有权拒绝付款且不构成违约；若合同执行期间，遇国家税务政策调整所引起的合同价格变化，按照不含税价格调整结算价格。
        </span>
      </span>
    </p>
    <p class="text-left text-indent-37 line-height-39">
      <span class="content">
        3、<span
          >如中标单位未及时向采购人提供符合本合同约定的请款资料或发票，采购人有权拒绝支付服务费，且不承担相应的违约责任。
        </span>
      </span>
    </p>
    <p class="text-left text-indent-37 line-height-39">
      <span class="content">
        4、<span
          >如按评分标准有扣分情况，所需扣金额应从该月承包款中扣除。采购人每月按评分标准对中标人进行考核，按百分制打分，具体惩罚措施详见评分表。
        </span>
      </span>
    </p>
    <p class="text-left text-indent-37 line-height-39 content">
      八、<span class="heading">派单方式</span>
    </p>
    <p class="text-left text-indent-37 line-height-39">
      <span class="content">
        <span>所有中标的供应商会按照中标的排名先后顺序进行排号。 </span>
      </span>
    </p>
    <p class="text-left text-indent-37 line-height-39">
      <span class="content">
        <span
          >当有新的项目或任务需要分配时，采购方会按照排号的顺序依次向供应商分配任务。
        </span>
      </span>
    </p>
    <p class="text-left text-indent-37 line-height-39">
      <span class="content">
        <span
          >每完成一次任务分配后，该供应商的排号会调整到最后，其他供应商的排号则向前累进一位。
        </span>
      </span>
    </p>

    <p class="text-left text-indent-37 line-height-39 content">
      九、<span class="heading"
        ><span class="star"></span>
        响应文件的组成部分（响应文件1-6项资料如有不全，则作无效报价处理）</span
      >
    </p>

    <p class="text-left text-indent-37 line-height-39">
      <span class="content"> 1、<span>报价清单； </span> </span>
    </p>
    <p class="text-left text-indent-37 line-height-39">
      <span class="content"> 2、<span>法定代表人身份证复印件； </span> </span>
    </p>
    <p class="text-left text-indent-37 line-height-39">
      <span class="content">
        3、<span>法人授权委托书（模板）及被委托人身份证复印件； </span>
      </span>
    </p>
    <p class="text-left text-indent-37 line-height-39">
      <span class="content"> 4、<span>承诺函（模板）； </span> </span>
    </p>
    <p class="text-left text-indent-37 line-height-39">
      <span class="content"> 5、<span>安全及环保承诺书（模板）； </span> </span>
    </p>
    <p class="text-left text-indent-37 line-height-39">
      <span class="content"> 6、<span>符合“响应人资格要求”对应的证明资料； </span> </span>
    </p>
    <p class="text-left text-indent-37 line-height-39">
      <span class="content"> 7、<span>响应人认为需要提供的其他资料。 </span> </span>
    </p>
    <p class="text-left text-indent-37 line-height-39">
      <span class="content">
        <span
          >响应人须严格按照采购人提供的表单格式报价，响应文件必须装订完整，于骑缝处加盖投标单位企业公章。装有响应文件的文件袋须贴有密封条，于骑缝处加盖企业公章。
        </span>
      </span>
    </p>

    <p class="text-left text-indent-37 line-height-39 content">
      十、<span class="heading"> 响应文件份数</span>
    </p>

    <p class="text-left text-indent-37 line-height-39">
      <span class="content block">
        <span>正本一份，副本叁份，并提供响应文件扫描件电子版（U盘）。 </span>
      </span>
    </p>

    <p class="text-left text-indent-37 line-height-39 content">
      十一、<span class="heading"> 保证金金额及缴纳方式</span>
    </p>
    <p class="text-left text-indent-37 line-height-39">
      <span class="content">
        <span>本项目不收取报价保证金和履约保证金。 </span>
      </span>
    </p>
    <p class="text-left text-indent-37 line-height-39 content">
      十二、<span class="heading"> 采取的合同文本</span>
    </p>
    <p class="text-left text-indent-37 line-height-39">
      <span class="content">
        <span
          >合同签订的依据为询价函、响应文件及补充说明等。确定成交单位后，成交单位在
          <span class="underline block">10</span>天内与采购人签订合同。
        </span>
      </span>
    </p>
    <p class="text-left text-indent-37 line-height-39 content">
      十三、<span class="heading"> 开标时间及开标地址</span>
    </p>
    <p class="text-left text-indent-37 line-height-39">
      <span class="content">
        <span
          >投标文件递交截止时间：
          <span class="underline block">2025年 7 月 14日</span>下午
          <span class="underline block">15:00</span>（星期一）
        </span>
      </span>
    </p>
    <p class="text-left text-indent-37 line-height-39">
      <span class="content">
        <span
          >开标时间： <span class="underline block">2025年 7 月 14日</span>下午
          <span class="underline block">15:00</span>（星期一）
        </span>
      </span>
    </p>
    <p class="text-left text-indent-37 line-height-39">
      <span class="content">
        <span
          >开标地址：
          <span class="underline block"
            >东莞市南城街道中天商业街28号1栋209室东进公司</span
          >
        </span>
      </span>
    </p>
    <p class="text-left text-indent-37 line-height-39">
      <span class="content">
        <span>联系人：杨恒（<span class="block">13728111174</span>） </span>
      </span>
    </p>

    <p class="text-left text-indent-37 line-height-39 content">
      十四、<span class="heading"> 注意事项</span>
    </p>
    <p class="text-left text-indent-37 line-height-39">
      <span class="content block">
        1、<span>本项目响应人需现场送达递交响应文件。 </span>
      </span>
    </p>
    <p class="text-left text-indent-37 line-height-39">
      <span class="content"
        ><span>若响应人未在开标时间前将文件送达现场，视为放弃投标资格。 </span>
      </span>
    </p>
    <p class="text-left text-indent-37 line-height-39">
      <span class="content">
        2、<span
          >采购人向响应人提供的有关资料和数据，是采购人现有的能使响应人利用的资料，采购人对响应人由此而做出的推论、理解和结论概不负责。
        </span>
      </span>
    </p>
    <p class="text-left text-indent-37 line-height-39">
      <span class="content">
        3、<span
          >本项目执行过程中将遵循国家、省、市有关法律法规、标准、技术规范和规范性文件的最新规定。
        </span>
      </span>
    </p>
    <p class="text-left text-indent-37 line-height-39">
      <span class="content">
        4、<span
          >成交单位对采购文件中技术条款作出的负偏离，采购人如不接受，可要求成交单位以采购文件的要求为准，如成交单位拒绝的，采购人有权取消其成交资格或取消合同。采购人不作任何补偿。
        </span>
      </span>
    </p>
    <p class="text-left text-indent-37 line-height-39">
      <span class="content">
        5、<span
          >本项目仅可提交一个报价方案，提交两个或以上报价方案的响应人视为无效报价。
        </span>
      </span>
    </p>
    <p class="text-left text-indent-37 line-height-39">
      <span class="content"> 6、<span>本项目不接受响应人其他附加条件。 </span> </span>
    </p>
    <p class="text-left text-indent-37 line-height-39">
      <span class="content">
        7、<span>有下列情形之一的，将纳入采购人供应商黑名单： </span>
      </span>
    </p>
    <p class="text-indent-37 line-height-39 text-autospace">
      <span class="number">（1）</span>
      <span class="content">中标后无正当理由放弃中标或不与采购人签订合同。 </span>
    </p>
    <p class="text-indent-37 line-height-39 text-autospace">
      <span class="number">（2）</span>
      <span class="content"
        >成交人将本项目转让给他人，或者在报价文件中未说明，且未经采购人同意，将中标项目分包给他人，采购人可没收其报价保证金。
      </span>
    </p>
    <p class="text-indent-37 line-height-39 text-autospace">
      <span class="number">（3）</span>
      <span class="content">报价人提供虚假报价文件或虚假补充文件。 </span>
    </p>

    <p class="text-right text-indent-37 line-height-39">
      <span class="content"> 广东东进有害生物防控技术有限公司</span>
    </p>
    <p class="text-right text-indent-37 line-height-39">
      <span class="content"> 2025年7月8日</span>
    </p>

    <p class="file-link-box">
      <a
        class="group1 cboxElement"
        href="http://www.dgsy.com.cn/include/ueditor/dialogs/attachment/fileTypeImages/icon_doc.gif"
        title=""
        ><img
          class="icon"
          src="http://www.dgsy.com.cn/include/ueditor/dialogs/attachment/fileTypeImages/icon_doc.gif" /></a
      ><a
        class="file-link"
        href="/20250708/东进公司东莞市内林业服务岗位外包采购项目（重新采购）.docx"
        title="东进公司东莞市内林业服务岗位外包采购项目（重新采购）.docx"
        >东进公司东莞市内林业服务岗位外包采购项目（重新采购）.docx</a
      >
    </p>
    <p class="file-link-box">
      <a
        class="group1 cboxElement"
        href="http://www.dgsy.com.cn/include/ueditor/dialogs/attachment/fileTypeImages/icon_pdf.gif"
        title=""
        ><img
          class="icon"
          src="http://www.dgsy.com.cn/include/ueditor/dialogs/attachment/fileTypeImages/icon_pdf.gif" /></a
      ><a
        class="file-link"
        href="/20250708/东进公司东莞市内林业服务岗位外包采购项目（重新采购）.pdf"
        title="东进公司东莞市内林业服务岗位外包采购项目（重新采购）.pdf"
        >东进公司东莞市内林业服务岗位外包采购项目（重新采购）.pdf</a
      >
    </p>
  </div>
</template>
<script>
export default {
  name: "DocDisplay",
  data() {
    return {
    };
  },
};
</script>

<style lang="scss" scoped>
.star {
  display: inline-block;
  color: black;
  width: 15px;
  height: 15px;
  position: relative;
}
.star::before,
.star::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 15px;
  height: 15px;
  background: currentColor;
  clip-path: polygon(
    50% 0%,
    61% 35%,
    98% 35%,
    68% 57%,
    79% 91%,
    50% 70%,
    21% 91%,
    32% 57%,
    2% 35%,
    39% 35%
  );
}

.underline {
  text-decoration: underline;
  text-underline-offset: 5px;
}

.content_con {
  font-size: 14px;
  font-family: "宋体", Arial;
  padding: 0px 50px;
  color: #515050;

  a {
    text-decoration: none;
    color: inherit;
  }

  .fa {
    color: #333;
    font-size: 12px;
  }

  .line-height-2em {
    line-height: 2em;
  }

  .text-center {
    text-align: center;
  }

  .margin-bottom-21 {
    margin-bottom: 21px;
  }

  .title {
    font-size: 27px;
    font-family: 方正小标宋简体;
  }

  .text-indent-37 {
    text-indent: 37px;
  }

  .line-height-39 {
    line-height: 39px;
  }

  .content {
    font-weight: 200;
    font-size: 19px;
    font-family: 仿宋_GB2312;
  }

  .heading {
    font-size: 19px;
    font-family: 黑体;
  }

  .block {
    font-family: 黑体;
    color: #000;
    font-weight: 500;
  }

  .red_text {
    color: red;
  }

  .number {
    font-size: 19px;
    font-family: "Times New Roman", "serif";
  }

  .underline {
    text-decoration: underline;
  }

  .text-left {
    text-align: left;
  }
  .text-right {
    text-align: right;
  }

  .text-autospace {
    margin: 3px;
    padding: 3px;

    span {
      color: #515050;
      font-size: 14px !important;
    }
  }

  .icon {
    vertical-align: middle;
    margin-right: 2px;
  }

  .file-link-box {
    margin: 3px;
    padding: 3px;
    font-size: 14px;
    text-indent: 22px;
    line-height: 16px;
  }

  .file-link {
    font-size: 12px;
    color: #0066cc;
  }
}
</style>
